.menu-item.selected:hover,
.menu-item.selected {
	color: var(--ds-text-inverse, var(--adg3-color-N20));
	background-color: var(--ds-background-neutral-bold-hovered, var(--adg3-color-N700));
	border-radius: 0;
}
